import { getSignedUpViaID } from "Signups/SharedComponents/getSignedUpViaID";

import {
  convertExtendedFieldInputResponses,
  convertSharedExtendedFieldInputResponses,
} from "./dataTranformations";

export async function composeNonHouseholdSubmitData({
  respondents,
  signupItemID,
  extendedFieldInputResponses,
  sharedExtendedFieldInputResponses,
  extendedFields,
}) {
  const selectedRespondents = respondents.filter((r) => r.isChecked);

  // for this we use total number of people (regardless of household or "additional name" status)
  const numberOfSlots = selectedRespondents.length;

  // we only need to include a user if it's an anonymousUser that is signing up.
  // otherwise, the endpoint will signup up the currently logged in user.
  let user = null;
  if (respondents[0].isAnonymousUser) {
    user = {
      emailOrPhone: respondents[0].emailOrPhone,
      name: respondents[0].name,
    };
  }

  // an array of strings: just the names of the "additional name" entries that were manually typed in
  const additionalNames = selectedRespondents
    .filter((r) => r.isAdditionalName)
    .map((r) => r.name);

  const signedUpViaID = getSignedUpViaID();

  return {
    signupItemID, // required!
    user,
    numberOfSlots,
    additionalNames,
    signedUpViaID,
    extendedFieldInputResponses: await convertExtendedFieldInputResponses(
      extendedFieldInputResponses,
      extendedFields
    ),
    sharedExtendedFieldInputResponses:
      await convertSharedExtendedFieldInputResponses(
        sharedExtendedFieldInputResponses,
        extendedFields
      ),
  };
}
